import React, { useEffect } from "react"
import { CodeTemplates } from "../../../../../Constantes/codeDocumentationTemplates";
import { CheckBox, TextBox } from "devextreme-react";
import DateBox from "../../../../common/CustomDateBox";
import { BackOfficeForm } from "../letters/BackOfficeForm";
import { useDispatch, useSelector } from "react-redux";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";


function DocumentationLettersForm(props){

    const {templateCode, template, setNames, classes, dataForm, onChange} = props;
    const dispatch = useDispatch();
    const subtypes = useSelector(selectTaxonomyTemplates);

    useEffect(()=>{
        if(template){
            dispatch(getTaxonomyTemplates({query: "?templateCode=" + template.code}))
            .then(
                (response)=> {
                    const defaultSubType = response.payload.find(subtype=> subtype.code === template.code)
                    onChange("subType", defaultSubType);
                }
            );
        }   
    },[template])

    useEffect(()=>{
        let defaultNames =["email"];
        let templateCode = template == null ? '' :template.code;
        if(templateCode === CodeTemplates.FIRST_DRIVER || templateCode === CodeTemplates.SECOND_DRIVER ){
            defaultNames.push("driverName");
            defaultNames.push("driverId");
        }
        if(templateCode === CodeTemplates.TRAVEL_ABROAD){
            defaultNames.push("driverName");
            defaultNames.push("driverId");
            defaultNames.push("closeDate");
        }
        if(templateCode === CodeTemplates.ITV){
            defaultNames.push("itv")
        }
        if(templateCode === CodeTemplates.ACCESORY_ASSEMBLY){
            defaultNames.push("name")
            defaultNames.push("surname")
            defaultNames.push("phoneNumber")
            defaultNames.push("email")
            defaultNames.push("dni")
            defaultNames.push("accesoryName")
        }
        setNames(defaultNames)

    },[template])

    let labelName = "";
    let labelMtr = "Mtr";
    let labelId = "";
    let labelEmail = "Correo electrónico";
    let labelCountries = "";
    let labelRevision = "Revisión";
    let labelContractNumber = "Nº contrato";
    let labelFleetManager = "Fleet Manager";
    let labelDriverSurname = "Apellidos del segundo conductor";
    let labelCif = "CIF";
    let names = [];


    function onChangeMtr(value){
        onChange("mtr", value);
        if(value){
            const mtrType = subtypes.find(subtype=> subtype.code.includes("_mtr"))
            onChange("subType", mtrType)
        } else {
            const defaultSubType = subtypes.find(subtype=> subtype.code === template.code)
            onChange("subType", defaultSubType)
        }
    }


    switch(templateCode){
        case CodeTemplates.FIRST_DRIVER:
            case CodeTemplates.SECOND_DRIVER:
                switch (templateCode) {
                    case CodeTemplates.FIRST_DRIVER:
                        labelName = "Nombre del conductor habitual";
                        labelDriverSurname = "Apellidos del conductor habitual";
                        labelId = "DNI del conductor habitual"
                    break;
                    case CodeTemplates.SECOND_DRIVER:
                        labelName = "Nombre del segundo conductor";
                        labelId = "DNI del segundo conductor"
                    break;
                }
                names.push("driverName");
                names.push("driverId");
                names.push("email");
                return(<div style={{display: "flex", flexDirection: "column", rowGap: "1rem"}}> 
                        <div className="template-checkbox-container">
                            <CheckBox key={labelName} name="mtr" value={dataForm.mtr} onValueChanged={(e) => onChangeMtr(e.value)}/>
                            <label>{labelMtr}</label> 
                        </div> 

                <div className="grid-two-columns">
                        <TextBox label={labelName} labelMode="floating" maxLength={70} key={labelName} name="driverName" value={dataForm.driverName} onValueChanged={(e) => onChange("driverName",e.value)} className={classes.controlers} ></TextBox>
                        {CodeTemplates.SECOND_DRIVER &&
                            <TextBox label={labelDriverSurname} labelMode="floating" maxLength={70} key={labelDriverSurname} name="driverSurname" value={dataForm.driverSurname} onValueChanged={(e) => onChange("driverSurname",e.value)} className={classes.controlers} ></TextBox>
                        }
                </div>     
                <div className="grid-two-columns">
                            <TextBox label={labelId} labelMode="floating" maxLength={20} key={labelId} name="driverId" value={dataForm.driverId} onValueChanged={(e) => onChange("driverId",e.value)} className={classes.controlers} ></TextBox>
                            <TextBox label={labelEmail} labelMode="floating" maxLength={50} key={labelEmail} name="driverId" value={dataForm.email} onValueChanged={(e) => onChange("email",e.value)}  className={classes.controlers} ></TextBox>
                </div>
                {dataForm.mtr &&
                    <>
                        <TextBox label={labelFleetManager} labelMode="floating" maxLength={50} key={labelFleetManager} name="fleetManager" value={dataForm.fleetManager} onValueChanged={(e) => onChange("fleetManager",e.value)}  className={classes.controlers} ></TextBox>
                        <BackOfficeForm classes={classes} dataForm={dataForm} onChange={onChange} templateCode={templateCode}/>
                    </>
                }
                </div>
                );
            case CodeTemplates.TRAVEL_ABROAD:
                labelName = "Nombre del autorizado";
                labelId = "DNI del autorizado";
                labelCountries = "País a autorizar";
                names.push("driverName");
                names.push("driverId");
                names.push("closeDate");
                names.push("email");
                names.push("authorizedCountries")
                return(<div style={{display: "flex", flexDirection: "column", rowGap: "1rem"}}>
                        <div className="template-checkbox-container">
                            <CheckBox key={labelName} name="mtr" value={dataForm.mtr} onValueChanged={(e) => onChangeMtr(e.value)} />
                            <label>{labelMtr}</label> 
                        </div>
                        <div className="grid-two-columns">
                            <TextBox label={labelName} labelMode="floating"  maxLength={70} key={labelName} name="driverName" value={dataForm.driverName} onValueChanged={(e) => onChange("driverName",e.value)}  className={classes.controlers} ></TextBox>
                            <TextBox label={labelId} labelMode="floating" maxLength={20} key={labelId} name="driverId" value={dataForm.driverId} onValueChanged={(e) => onChange("driverId",e.value)}  className={classes.controlers} ></TextBox>
                            <TextBox label={labelCountries} labelMode="floating" maxLength={50} key={labelCountries} name="authorizedCountries" value={dataForm.authorizedCountries} onValueChanged={(e) => onChange("authorizedCountries",e.value)}  className={classes.controlers} ></TextBox>
                            <DateBox
                            placeholder=""
                            className={classes.controlers} 
                            label={"Fecha de fin"}
                            labelMode="floating"
                            name="closeDate"
                            value={dataForm.closeDate}
                            showClearButton={true}
                            useMaskBehavior={true}
                            dateSerializationFormat="yyyy-MM-dd"
                            displayFormat="dd/MM/yyyy"
                            acceptCustomValue={false}
                            onValueChanged={(e) => onChange("closeDate",e.value)} />
                        <TextBox label={labelEmail} labelMode="floating" maxLength={50} key={labelEmail} name="driverId" value={dataForm.email} onValueChanged={(e) => onChange("email",e.value)}  className={classes.controlers} ></TextBox>
                        </div>
            {dataForm.mtr &&
                <div className="grid-two-columns">
                        <TextBox label={labelFleetManager} labelMode="floating" maxLength={50} key={labelFleetManager} name="fleetManager" value={dataForm.fleetManager} onValueChanged={(e) => onChange("fleetManager",e.value)}  className={classes.controlers} ></TextBox>
                        <TextBox label={labelCif} labelMode="floating" key={labelCif} name="cif" value={dataForm?.cif} onValueChanged={(e) => onChange("cif", e.value)} className={classes.controlers} ></TextBox>
                </div>
            }
    
                {(dataForm.mtr) &&
                <BackOfficeForm classes={classes} dataForm={dataForm} onChange={onChange} templateCode={templateCode}/>
                }
            </div>);
            case CodeTemplates.ITV:
                labelName = "Nombre de ITV";
                names.push("itv");
                names.push("email");
                return(
                    <div className="grid-two-columns">
                        <TextBox label={labelName} labelMode="floating" maxLength={70} key={labelName} name="itv" value={dataForm.itv} onValueChanged={(e) => onChange("itv",e.value)}  className={classes.controlers} ></TextBox>
                        <TextBox label={labelEmail} labelMode="floating"  maxLength={50} key={labelEmail} name="driverId" value={dataForm.email} onValueChanged={(e) => onChange("email",e.value)}  className={classes.controlers} ></TextBox> 
                    </div>
                );
            case CodeTemplates.RENT:
                names.push("email");
                return(
                <div style={{display: "flex", flexDirection: "column", rowGap: "1rem"}}>
                    <div className="template-checkbox-container">
                        <CheckBox key={labelName} name="mtr" value={dataForm.mtr} onValueChanged={(e) => onChangeMtr(e.value)} />
                        <label>{labelMtr}</label> 
                    </div>
                        <TextBox label={labelEmail} labelMode="floating" maxLength={50} key={labelEmail} name="driverId" value={dataForm.email} onValueChanged={(e) => onChange("email",e.value)}  className={classes.controlers} ></TextBox>
                {dataForm.mtr &&
                <div className="grid-two-columns">

                    <TextBox label={labelContractNumber} labelMode="floating" maxLength={50} key={labelContractNumber} name="contractNumber" value={dataForm.contractNumber} onValueChanged={(e) => onChange("contractNumber",e.value)}  className={classes.controlers} ></TextBox>
                    <TextBox label={labelRevision} labelMode="floating" maxLength={50} key={labelRevision} name="revision" value={dataForm.revision} onValueChanged={(e) => onChange("revision",e.value)}  className={classes.controlers} ></TextBox>
                </div>
                }
    
                {(dataForm.mtr) &&
                <BackOfficeForm classes={classes} dataForm={dataForm} onChange={onChange} templateCode={templateCode}/>
                }
                </div>
                )
            default:
                return <></>
    }
}

export {DocumentationLettersForm}